var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchCategoryDatabase16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/16/Database_16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linear-gradient-aws/Category-Icons/Arch-Category_16/Arch-Category_Database_16.svg"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E27AD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/16/Database_16",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linear-gradient-aws/Category-Icons/Arch-Category_16/Arch-Category_Database_16.svg)",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border-Copy-9",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/16/Database_16",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,7.736 C4.765,7.736 3,6.782 3,6.293 L3,3.814 C4.133,4.496 6.071,4.849 8,4.849 C9.929,4.849 11.867,4.496 13,3.814 L13,6.293 C13,6.782 11.235,7.736 8,7.736 M8,11.554 C4.765,11.554 3,10.601 3,10.111 L3,7.7 C4.133,8.383 6.071,8.736 8,8.736 C9.929,8.736 11.867,8.383 13,7.7 L13,10.111 C13,10.601 11.235,11.554 8,11.554 M8,14.963 C4.765,14.963 3,14.009 3,13.52 L3,11.519 C4.133,12.201 6.071,12.554 8,12.554 C9.929,12.554 11.867,12.201 13,11.519 L13,13.52 C13,14.009 11.235,14.963 8,14.963 M8,0.963 C11.235,0.963 13,1.917 13,2.406 C13,2.896 11.235,3.849 8,3.849 C4.765,3.849 3,2.896 3,2.406 C3,1.917 4.765,0.963 8,0.963 M2,2.406 L2,13.52 C2,15.124 5.019,15.963 8,15.963 C10.981,15.963 14,15.124 14,13.52 L14,2.406 C14,-0.802 2,-0.802 2,2.406",
    id: "Database_Category-Icon_16_Squid--"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategoryDatabase16);
export default __webpack_public_path__ + "static/media/Arch-Category_Database_16.c25a7d998c39f3a885d8bccca496d579.svg";
export { ForwardRef as ReactComponent };